<script setup lang="ts">
import ModalContainer from '@/components/modal/modal-container.vue'
import ModalTitle from '@/components/modal/modal-title.vue'
import ModalContent from '@/components/modal/modal-content.vue'
import ModalFooter from '@/components/modal/modal-footer.vue'
import ButtonSecondary from '@/components/button-secondary.vue'
import { computed } from 'vue'
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons'

const props = defineProps<{
  creditNoteNames: string[]
  invoiceId: number
  projectName: string
  projectCode: number
  assetCode: string
}>()

const formattedCount = computed(
  () => {
    switch (props.creditNoteNames.length) {
      case 0: return 'were some credit note(s)';
      case 1: return 'was 1 credit note';
      default: return `were ${props.creditNoteNames.length} credit notes`;
    }
  }
)
</script>

<template>
  <ModalContainer>
    <ModalTitle>Please note</ModalTitle>
    <ModalContent :icon="faExclamationTriangle" icon-variant="warning">
      <p>Invoice <b>{{ invoiceId }}</b> for <b>{{ projectName }} (Project: {{ projectCode }} | Asset: {{ assetCode }})</b> was approved, but there {{ formattedCount }} that could not be applied after multiple attempts.</p>
      <template v-if="creditNoteNames.length > 0">
        <p>The following credit note{{ creditNoteNames.length === 1 ? '' : 's' }} could not be applied:</p>
        <ul class="mt-2">
          <li v-for="name in creditNoteNames" :key="name">{{ name }}</li>
        </ul>
      </template>
      <p>Please review the credit note values in Xero. Once you've confirmed the values are available, cancel and recreate the invoice and then retry approval.</p>
    </ModalContent>
    <ModalFooter class="text-end">
      <ButtonSecondary @click="$emit('close')">Close</ButtonSecondary>
    </ModalFooter>
  </ModalContainer>
</template>

<style scoped lang="scss">

</style>
